module.exports = new __parcel__URL__("Fundraising Database Hover.e1687271.svg").toString();